import { MapContainer, TileLayer,useMapEvents, Marker, Popup, useMap } from "react-leaflet";
import React, { useState,useEffect, useContext, useRef } from "react";
import "leaflet/dist/leaflet.css";
import L, { point, routing } from "leaflet";
import './map.css';
import "leaflet-routing-machine";
import { withLeaflet } from "react-leaflet";
import { Rating } from "react-simple-star-rating";
import current_icon from './icons/current.webp';
import store_icon from './icons/shop.webp';
import home_icon from './icons/home.webp';
import user_icon from './icons/useradress.webp';
import dollar_icon from '../user/icons/dollar.webp';
import localisation_icon from './icons/localisation.webp';


const RoutingControl = ({ from, to }) => {
  const map = useMap();
  const routingRef = useRef(null); // pour stocker la référence proprement
  useEffect(() => {
    if (!map) return;
    // Supprimer le précédent routingControl s'il existe
    if (routingRef.current) {
      map.removeControl(routingRef.current);
    }
    const routingControl = L.Routing.control({
      waypoints: [L.latLng(from[0], from[1]), L.latLng(to[0], to[1])],
      createMarker: ()=>null,
      routeWhileDragging: true,
      show: false,
      addWaypoints: false,
      draggableWaypoints: false,
    }).addTo(map);

    routingRef.current = routingControl;

    // Nettoyage
    return () => {
      if (routingRef.current) {
        try {
          map.removeControl(routingRef.current);
          routingRef.current = null;
        } catch (err) {
          console.warn('Erreur lors de la suppression du routing control :', err);
        }
      }
    };
  }, [map, from, to]);

  return null;
};


function ReperePopUp(location, setRoute=()=>{}, route = {})
{
  const boutique_icon = L.divIcon({
    html: `
    <div  class="user-marker">
        <img src="${store_icon}" alt="Marker Image">
    </div>
  `,
    iconSize: [0, 0], 
    iconAnchor: [5, 5],
    popupAnchor:[-5,-5]
  });

  const user_point_icon = L.divIcon({
    html: `
      <div  class="user-marker">
          <img src="${home_icon}" alt="Marker Image">
      </div>
    `,
    className: "", // Remove default styling
    iconSize: [25, 25], 
    iconAnchor: [15, 25],
    popupAnchor:[-20,-20]
  });

  const self_icon = L.divIcon({
    html: `
      <div  class="user-marker">
          <img src="${current_icon}" alt="Marker Image">
      </div>
    `,
    className: "", // Remove default styling
    iconSize: [25, 25], 
    iconAnchor: [15, 25],
    popupAnchor:[-20,-20]
  });

  const new_point_icon = new L.Icon({
    iconUrl: localisation_icon,
    iconSize: [50,50],
    iconAnchor: [30, 55]
  });

  const OnItinClick = ()=>
  {
    setRoute({...route,display:true, to:[location.coords.latitude,location.coords.longitude]});
  }

  switch(location.type)
  {
      case 'user_point':
        return({icon:user_point_icon,
          popup:
          <Popup>
            <span style={{fontSize:'x-small',fontWeight:'bold'}}>{location.label}</span>
          </Popup>})
      case 'new_point':
        return({icon:new_point_icon,popup:""})
      case 'partner_point':
        return({
              popup:<Popup><span style={{fontSize:'x-small',fontWeight:'bold'}}></span>
                        <div style={{display:'inline-block',fontSize:'x-small'}}>
                          <span style={{fontWeight:'bold'}}>{location.label}</span><br/>
                          <span style={{fontSize:'x-small'}}>Tel : {location.phone}</span><br/>
                          <Rating initialValue={2.5} size={'10px'} />
                        </div>
                      </Popup>,
              icon:boutique_icon});
      case 'delivery_point':
        return({
              popup:<Popup key={location}>
                        <div style={{display:'inline-block',fontSize:'x-small'}}>
                            <span style={{fontWeight:'bold'}}>{location.label}</span><br/>
                            <span style={{fontSize:'x-small'}}>Tel : {location.phone}</span><br/>
                            <span style={{fontSize:'x-small',fontWeight:'bold'}}>Commandes : </span><br/>
                            {
                              location.orders.map((ord)=>{
                                  return <><span style={{fontSize:'x-small',color:'gray'}}>{ord}</span><br/></>
                              })
                            }
                            <input onClick={e=>{OnItinClick();}} type="button" value={'intinéraire'} style={{float:'inline-end',margin:'5px',padding:'5px 10px 5px 10px',height:'25px',backgroundColor:'skyblue',fontSize:'x-small',borderRadius:'5px',width:'fit-content',border:'none'}} />
                        </div>
                      </Popup>,
              icon:boutique_icon});
      case 'self':
        return({icon:self_icon,
          popup:
          <Popup>
            <span style={{fontSize:'x-small',fontWeight:'bold'}}>{"Vous"}</span>
          </Popup>});
      case 'payment':
        const dollar = new L.Icon({
          iconUrl: dollar_icon,
          iconSize: [65,65],
          iconAnchor: [30, 55]
        });
        return({
              popup:<Popup>
                        <div style={{display:'inline-block',fontSize:'x-small'}}>
                            <span style={{fontWeight:'bold'}}>{location.label}</span><br/>
                            <span style={{fontSize:'x-small'}}>Tel : {location.phone}</span><br/>
                            <span style={{fontSize:'x-small',fontWeight:'bold'}}>Sommes : </span><br/>
                            {
                              location.mounts.map((mount)=>{
                                  return <><span style={{fontSize:'x-small',color:'gray'}}>{mount}</span><br/></>
                              })
                            }
                            <input onClick={e=>{OnItinClick();}} type="button" value={'intinéraire'} style={{float:'inline-end',margin:'5px',padding:'5px 10px 5px 10px',height:'25px',backgroundColor:'skyblue',fontSize:'x-small',borderRadius:'5px',width:'fit-content',border:'none'}} />
                        </div>
                      </Popup>,
              icon:dollar});
      case 'track_delivery':
        const delivery = new L.Icon({
          iconUrl: "/images/icons/delivry.webp",
          iconSize: [30,30],
          iconAnchor: [10, 10]
        });
        return({
              popup:<Popup>
                        <div style={{display:'inline-block',fontSize:'x-small'}}>
                            <span style={{fontWeight:'bold'}}>{location.label}</span><br/>
                            <span style={{fontSize:'x-small'}}>Tel : {location.phone}</span>
                        </div>
                      </Popup>,
              icon:delivery});
      
      default:
        return({icon:new_point_icon,popup:""})
  }
}

function Repere({map,location, setRoute = ()=>{}, route= {}})
{
  const [_location,setLocation] = useState(location);
  const [rep, setRep] = useState(ReperePopUp(location, setRoute, route= route));
  useEffect(()=>{
    setLocation(location);
    setRep(ReperePopUp(_location, setRoute, route= route));
  },[location])

  useEffect(()=>{

  },[rep])
  console.log("repere",_location);
  if(isNaN(_location.coords.latitude) || isNaN(_location.coords.longitude))
  {return;}
  //const 

  return(
    <Marker icon={rep.icon} position={[_location.coords.latitude, _location.coords.longitude]}>
        {!!rep && rep.popup}
    </Marker>
  );
}

function RecenterMap({setNewLocation=()=>{}, OnAddMarker=()=>{}, onMoveEnd=()=>{}, mapRef})
{
    const map = useMap();
    useEffect(()=>{
      if(navigator.geolocation)
      {
        try{
          navigator.geolocation.getCurrentPosition((position)=>{
              const {latitude, longitude} = position.coords;
              map.setView([latitude,longitude],13);
          });
        }
        catch{}
      }
    },[map])
    
    useMapEvents(
      {
        click(point){
          const result = OnAddMarker(point);
          console.log("add marker", result);
          if(result.result)
          {setNewLocation(<Repere location={result.location} />)}
        },
        moveend()
        {onMoveEnd(mapRef.current.getBounds());},
      });
}

export default function Map(
{
    OnAddMarker=(point)=>{return {result:false};},
    onMoveEnd=(bounds)=>{},
    locations, 
    zoom=15, 
    clearNewMark = false, 
    setClearNewMark= ()=>{},
    setComment = ()=>{},
    routing = {display:false, from:[-11.472917,43.393561], to:[-11.463004,43.38916]},
    map_center
  }) 
{
  const [_mapCenter,_setMapCenter] = useState({latitude:-11.470978, longitude:43.387745});
  //const [WayPoints,setWayPoints] = useState([{latitude:-11.470978, longitude:43.387745},{latitude:-11.463004,longitude:43.38916} ]);
  const [_locations,_setLocations] = useState(locations);
  const mapRef = useRef();
  const [route, setRoute] = useState(routing);
  const [currentPosition,setCurrentPosition] = useState(null);

  useEffect(() => {

    function isInComoros(lat, lng) {
      const comorosBounds = {
        north: -11.2,  // northernmost point
        south: -13.1,  // southernmost point
        east: 44.6,    // easternmost point
        west: 43.1     // westernmost point
      };
      return (
        lat >= comorosBounds.south &&
        lat <= comorosBounds.north &&
        lng >= comorosBounds.west &&
        lng <= comorosBounds.east
      );
    }
    /*
    if (!navigator.geolocation) {
      return;
    }
    */
    const watchId = navigator.geolocation.watchPosition(
      (pos) => {
          const { latitude, longitude } = pos.coords;
          if(!isInComoros(latitude,longitude))
              setComment("Vous n'êtes pas aux comores, ce service est non disponible");
          const _loc = {coords:{latitude:latitude,longitude:longitude},type:'self'};
          setCurrentPosition({location:_loc,marquer:<Repere location={_loc} />});
          setRoute({...route,from:[latitude,longitude]});
      },
      (err) => {
          setComment("Impossible de récupérer votre position");
      },
      {
        enableHighAccuracy: true, 
        timeout: 10000,
        maximumAge: 0
      }
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, []);
 
  useEffect(()=>
  {_setLocations(locations);},[locations]);

  useEffect(()=>{
    if(!!map_center)
      _setMapCenter(map_center);
  },[map_center])

  useEffect(()=>{
     if(!!currentPosition)
      setRoute({...route, display:routing.display,from:[currentPosition.location.coords.latitude,currentPosition.location.coords.longitude], to:routing.to});
  },[routing.display])

  const [newLocation,setNewLocation] = useState(null);

  useEffect(()=>{
    if(clearNewMark)
    {setNewLocation(null);setClearNewMark(false);}
  },[clearNewMark])
  /*
  useEffect(() => {
      if(!!mapRef.current)
        mapRef.current.setView([map_center.latitude, map_center.longitude]);
    }, [map_center]);
  */
  function MapView({center}) {
    //const map = useMap();
  

    return null;
  }

  
  
  useEffect(()=>{
    if(!!mapRef.current)
      onMoveEnd(mapRef.current.getBounds());
  },[mapRef.current])


  return (
    <MapContainer
        className="map"
        center={[_mapCenter.latitude, _mapCenter.longitude]}
        zoom={zoom}
        scrollWheelZoom={true}
        ref={mapRef}
        >
        <TileLayer attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>  contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {
            _locations.map((location,index)=>{  
              return (<Repere setRoute={setRoute} route={route} key={index} location={location} />);}
            )
          }
        {!!currentPosition && currentPosition.marquer}
        {newLocation}
        <RecenterMap setNewLocation={setNewLocation} onMoveEnd={onMoveEnd} OnAddMarker={OnAddMarker} mapRef={mapRef}/>
        {route.display && <RoutingControl from={route.from} to={route.to} />}
    </MapContainer>
  );
}
